import styled from 'styled-components'

import { Flex } from '@/ui/atoms/flex'
import { TRANSITION_STYLE } from '@/ui/constants/commonStyles'

export const R2SStructuredMessagesBox = styled(Flex)<{ isVisible: boolean }>(
  ({ isVisible }) => `
  ${TRANSITION_STYLE}

  overflow:hidden;
  // Set a height high enough that the dynamic content will fit 
  max-height: ${isVisible ? '25rem' : '0'};
  opacity: ${isVisible ? '1' : '0'};;
`
)
